module.exports = __webpack_public_path__ + "static/media/gitbook-icon.15df4d72.svg";